var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tag-group"},[_vm._t("default",null,{"color":_vm.color,"text":_vm.text})],2)}
var staticRenderFns = []

export { render, staticRenderFns }